<template>
  <FoldDrawer ref="foldDrawer" :fold-title="foldTitle" :unfold-title="unFoldTitle">
    <div slot="title" class="title-wrap">
      {{ title }}
      <div class="pic-control">
        <i class="iconfont icon-zoomIn bigger-btn" @click="zoomOut" />
        <i class="iconfont icon-zoomOut smaller-btn" @click="zoomIn" />
        <i class="iconfont icon-rotation rotate-btn" @click="handlexRotate" />
      </div>
    </div>
    <div class="pic-wrap">
      <Loading v-if="isLoading" class="answer-loading" />
      <ComNull v-else-if="!url" desc="暂无答案" />
      <template v-else>
        <div class="canvas-inner" ref="canvasWrap">
          <canvas
            ref="picCanvas"
          />
        </div>
      </template>
    </div>
  </FoldDrawer>
</template>
<script>
import FoldDrawer from '@/components/FoldDrawer.vue'
import corrService from '@/service/correction'
import { TITLE, FOLD_TITLE, UNFOLD_TITLE } from './constant'
import Loading from '@/components/Loading.vue'
import ComNull from '@/components/ComNull/ComNull.vue'
export default {
  components: {
    FoldDrawer,
    Loading,
    ComNull
  },
  props: {
    classTypeId: [Number, String],
    lessonId: [Number, String],
    aiLessonId: [Number, String]
  },
  data() {
    return {
      title: TITLE,
      foldTitle: FOLD_TITLE,
      unFoldTitle: UNFOLD_TITLE,
      url: null,
      isLoading: false
    }
  },
  methods: {
    async showAnswer() {
      const { classTypeId, aiLessonId } = this
      const { answerImg } = await corrService.firstExamWordAnswer([classTypeId, aiLessonId])
      // if (!answerImg) {
      //   // 答案为空
      //   message.error('日积月累答案为空')
      // }
      return answerImg || ''
    },
    getImg(url) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(url, (img, e) => {
          if (e) {
            reject(e)
          } else {
            resolve(img)
          }
        },
        { crossOrigin: 'anonymous' })
      })
    },
    async init() {
      if (this.isLoading) {
        return
      }
      if (this.url) {
        return
      }
      this.isLoading = true
      // 获取图片地址
      const answerImg = await this.showAnswer()
      const img = await this.getImg(answerImg)
      this.url = answerImg
      this.isLoading = false
      this.$nextTick(() => {
        this.angle = 0
        const { width } = this.$refs.picCanvas.getBoundingClientRect()
        const canvas = new fabric.Canvas(this.$refs.picCanvas, {
          preserveObjectStacking: true,
          isDrawingMode: false,
          backgroundColor: '#ffffff'
        })
        img.set({
          left: 0,
          top: 0,
          lockMovementX: true,
          lockMovementY: true,
          hasControls: false
        })
        this.img = img
        // 将图片添加到画布
        canvas.add(img)
        // 调整画布大小适配图片
        let initWidth
        let initHeight
        let zoom = 1
        if (img.width > width) {
          initWidth = width
          zoom = width / img.width
          initHeight = zoom * img.height
        } else {
          initWidth = img.width
          initHeight = img.height
        }
        canvas.setWidth(initWidth)
        canvas.setHeight(initHeight)
        canvas.setZoom(zoom)
        this.canvas = canvas
      })
    },
    zoomOut() {
      this.zoomIt(1.1)
    },
    zoomIn() {
      this.zoomIt(0.9)
    },
    zoomIt(factor) {
      const cWidth = this.canvas.width
      const cHeight = this.canvas.height
      const zoom = this.canvas.getZoom()
      this.canvas.setWidth(cWidth * factor)
      this.canvas.setHeight(cHeight * factor)
      this.canvas.setZoom(zoom * factor)
    },
    handlexRotate() {
      this.angle += 90
      this.canvas.setActiveObject(this.img)
      const img = this.canvas.getActiveObject()
      const { width, height } = this.canvas

      this.canvas.setWidth(height)
      this.canvas.setHeight(width)
      this.handleActiveObjectPosition(img)
    },
    handleActiveObjectPosition(obj) {
      obj.rotate(this.angle)
      const angleNum = this.angle % 360
      let left = 0
      let top = 0
      switch (angleNum) {
        case 90:
          left = obj.height
          break
        case 180:
          left = obj.width
          top = obj.height
          break
        case 270 :
          top = obj.width
          break
      }
      obj.set({
        left,
        top
      })
      this.canvas.requestRenderAll()
    },
    show() {
      this.$refs.foldDrawer.show()
      this.$nextTick(() => {
        this.init()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pic-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  .canvas-inner {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  canvas {
    width: 100%;
    height: 100%;
  }
}
.title-wrap {
  display: flex;
  align-items: center;
  .pic-control {
    margin-left: 16px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    position: relative;
    i {
      font-size: 16px;
      padding: 8px;
      font-weight: normal;
      color: #70788C;
      cursor: pointer;
      &:last-child {
        margin-right: 0
      }
    }
    &:after {
      position: absolute;
      content: "";
      width: 1px;
      height: 24px;
      background: #EBEDF0;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
}
</style>